module.exports = __webpack_public_path__ + "static/media/paid-landing-screen-footer.3f2e0bdb.png";